// export const categryTypeObj = {
//     0: "Telemed",
//     1: "Consultations",
//     2: "Laboratory",
//     3: "MRT",
//     4: "UZI",
//     5: "XRay",
//     6: "Proc",
//     7: "Instrumental",
//     '-1': "Unknown"
// }


export const categryTypeObj = {
    0: "Telemed",
    1: "Consultations",
    2: "Laboratory",
    3: "MRT",
    4: "UZI",
    5: "XRay",
    6: "Proc",
    7: "Instrumental",
    8: "Other",
    9: "Endoscopy",
    10: "Stomatology",
    11: "Cosmetology",
    12: "Gynecology",
    13: "Exercisetherapy",
    14: "Ct",
    15: "Funcdiagnostics",
}

export const payTypeObj = {
  0: 'Cash',
  1: 'Oms',
}
